export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-scale/src/colors.js
// module id = 31
// module chunks = 0 1 2 3 4